import * as Yup from 'yup';
import { SORTBY_OPTIONS, toolsSoftwares } from '../../utils/constants';
import { useEffect, useState } from 'react';

import SelectQuestion from '../SelectQuestion/SelectQuestion';
import YesNoButton from '../YesNoButton/YesNoButton';
import { createLocalizedOptions } from '../../pages/root/App';
import iconProgramming from '../../assets/images/ubisoft-playtest-programming-black.webp';

import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface Props {
  isInterested: boolean | null;
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
  withHeader?: boolean;
  isSurvey?: boolean;
}

const ToolsSoftwareTesting = ({
  isInterested,
  values,
  errors,
  setFieldValue,
  updateSchema,
  withHeader = true,
  isSurvey = false
}: Props) => {
  const intl = useIntl();
  const [interested, setInterested] = useState(isInterested);

  const toolsSoftwareOptions = createLocalizedOptions(
    toolsSoftwares,
    messages,
    SORTBY_OPTIONS.Name
  );

  useEffect(() => {
    const toolsSoftwareSchema = {
      toolsSoftwareIds: Yup.array(Yup.number())
        .min(1, intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
        .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
    };
    updateSchema(toolsSoftwareSchema);
  }, []);

  return (
    <div className="tools-software">
      {withHeader && (
        <div className="header">
          <img src={iconProgramming} alt="" className="mt-n1" />
          <h3>{intl.formatMessage({ ...messages.headerToolsSoftware })}</h3>
        </div>
      )}
      {isSurvey && (
        <div className="mt-3">
          <YesNoButton
            id="candidateToolsSoftware"
            name="toolsSoftwareTesting"
            label={intl.formatMessage({ ...messages.toolsSoftwareTesting })}
            value={interested}
            onChange={(value: boolean) => {
              setInterested(value);
              setFieldValue('toolsSoftwareTesting', value);
            }}
          />
        </div>
      )}
      <div className="content">
        {!isSurvey && (
          <YesNoButton
            id="candidateToolsSoftware"
            name="toolsSoftwareTesting"
            label={intl.formatMessage({ ...messages.toolsSoftwareTesting })}
            value={isInterested}
            onChange={(value: boolean) => {
              setInterested(value);
              setFieldValue('toolsSoftwareTesting', value);
            }}
          />
        )}
        {interested && (
          <>
            <SelectQuestion
              prefix="candidateToolsSoftware"
              controlId="toolsSoftwareIds"
              label={intl.formatMessage({ ...messages.toolsSoftwares })}
              isMulti={true}
              options={toolsSoftwareOptions}
              value={values.toolsSoftwareIds ?? []}
              error={
                typeof errors == 'string' ? errors : errors?.toolsSoftwareIds
              }
              setFieldValue={setFieldValue}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ToolsSoftwareTesting;
